// Parse an App Store URL and extract the numeric app ID, or return null if the
// input is not a recognizable App Store URL.
//
// Supported formats:
//   https://apps.apple.com/us/app/some-name/id123456789
//   https://itunes.apple.com/us/app/id123456789
//   https://apps.apple.com/app/id123456789?country=us   (query-string variant)
//   https://apps.apple.com/us/app/name/id123456789?mt=8
//   apps.apple.com/... (without protocol)
//
// Returns null for plain numeric IDs (caller should pass those through as-is)
// and for anything that doesn't look like an Apple URL.

const APP_STORE_URL_RE = /\bid(\d{6,12})\b/;

/**
 * @param {string} input
 * @returns {string|null} The numeric app ID string, or null.
 */
export function parseAppStoreUrl(input) {
  if (!input || typeof input !== 'string') return null;
  const trimmed = input.trim();

  // Must look like an Apple URL — reject plain numbers and non-Apple URLs early.
  if (!/apple\.com/i.test(trimmed)) return null;

  const match = trimmed.match(APP_STORE_URL_RE);
  if (!match) return null;
  return match[1];
}
